import {
  Paper,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Stack,
  CircularProgress,
  SelectChangeEvent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { AnnotationSource } from '@/api/annotationSource';

interface AnnotationSourcesSelectorProps {
  annotationSources: AnnotationSource | AnnotationSource[];
  watchSelectedSources: string[];
  handleSourceChange2: (event: SelectChangeEvent<string[]>) => void;
  sourcesLoading: boolean;
  typographyText: string;
}

const AnnotationSourcesSelector = ({
  annotationSources,
  watchSelectedSources,
  handleSourceChange2,
  sourcesLoading,
  typographyText,
}: AnnotationSourcesSelectorProps) => (
  <Accordion>
    <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
      <Typography>{typographyText}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          borderRadius: 3,
          backgroundColor: 'background.default',
          minWidth: 300,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="body1" fontWeight={600}>
            Sources
          </Typography>
          {sourcesLoading && <CircularProgress size={20} />}
        </Stack>

        <Divider sx={{ mb: 2 }} />

        <FormControl fullWidth size="small" disabled={sourcesLoading}>
          <InputLabel>Select Annotation Sources</InputLabel>
          <Select
            label="Select Annotation Sources"
            multiple
            value={watchSelectedSources}
            onChange={handleSourceChange2}
            renderValue={(selected) =>
              (Array.isArray(annotationSources) ? annotationSources : [])
                .filter((source) => selected.includes(source.id.toString()))
                .map((source) => source.name)
                .join(', ')
            }
          >
            {Array.isArray(annotationSources) &&
              annotationSources.map((source) => (
                <MenuItem key={source.id} value={source.id.toString()}>
                  <Checkbox
                    checked={watchSelectedSources.includes(
                      source.id.toString(),
                    )}
                  />
                  <ListItemText primary={source.name} />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Paper>
    </AccordionDetails>
  </Accordion>
);

export default AnnotationSourcesSelector;
